/* =============================================================
   Maybe Sammy Cocktails — ms-enhance.js
   Social wall (in-view autoplay) + email pop-up.
   Self-contained; loads after global.js. No dependencies.
   ============================================================= */
(function () {
  'use strict';
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Social wall (in-view muted autoplay) ---------- */
  function initSocial(root) {
    var vids = $$('[data-ms-social-video]', root || document);
    if (!vids.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && en.intersectionRatio > 0.5) {
          if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (!v.paused) { v.pause(); }
      });
    }, { threshold: [0, 0.5, 1] });
    vids.forEach(function (v) { if (v.dataset.ioBound) return; v.dataset.ioBound = '1'; io.observe(v); });
  }

  /* ---------- Email pop-up ---------- */
  function initPopup() {
    var popup = document.getElementById('ms-popup');
    if (!popup || popup.dataset.popupBound) return;
    popup.dataset.popupBound = '1';
    var KEY = 'ms_popup_seen', SUBMIT = 'ms_popup_submit';
    var design = !!(window.Shopify && window.Shopify.designMode);
    var freqDays = parseInt(popup.getAttribute('data-frequency'), 10) || 14;
    var delay = parseInt(popup.getAttribute('data-delay'), 10); if (isNaN(delay)) delay = 6;
    var exitOn = popup.getAttribute('data-exit') === '1';
    var form = popup.querySelector('#ms-popup-form');
    var success = popup.querySelector('[data-ms-popup-success]');

    function suppressed() {
      if (design) return false;
      try { var t = parseInt(localStorage.getItem(KEY), 10); return t ? (Date.now() - t) < freqDays * 86400000 : false; }
      catch (e) { return false; }
    }
    function markSeen() { if (design) return; try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
    function open() { popup.classList.add('is-open'); popup.setAttribute('aria-hidden', 'false'); }
    function close() { popup.classList.remove('is-open'); popup.setAttribute('aria-hidden', 'true'); markSeen(); }

    $$('[data-ms-popup-close]', popup).forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && popup.classList.contains('is-open')) close(); });

    var copyBtn = popup.querySelector('[data-ms-popup-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-code') || '';
        var done = function () { copyBtn.textContent = 'Copied'; copyBtn.classList.add('is-copied'); };
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done).catch(done); } else { done(); }
      });
    }
    if (form) { form.addEventListener('submit', function () { try { sessionStorage.setItem(SUBMIT, '1'); } catch (e) {} }); }

    if (design) {
      document.addEventListener('shopify:section:select', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('#ms-popup')) open(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('#ms-popup')) close(); });
      return;
    }

    if (success) {
      var fromPopup = false;
      try { fromPopup = sessionStorage.getItem(SUBMIT) === '1'; sessionStorage.removeItem(SUBMIT); } catch (e) {}
      if (fromPopup) { open(); markSeen(); }
      return;
    }
    if (suppressed()) return;

    var opened = false;
    function trigger() { if (opened) return; opened = true; open(); }
    if (delay >= 0) setTimeout(trigger, delay * 1000);
    if (exitOn) document.addEventListener('mouseout', function (e) { if (e.clientY <= 0 && !e.relatedTarget) trigger(); });
  }

  function boot(root) { initSocial(root || document); initPopup(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
